module.exports = __webpack_public_path__ + "static/media/crumlin2.6578aa61.png";